import { ApplicationView } from '@aha-app/mvc';
import React from 'react';
import styles from './VotingSession.module.css';

const DeleteConfirmation = ({ widget, onConfirm, onCancel }) => {
  return (
    <div>
      <p className='t-100'>
        Delete <strong>{widget.name}</strong>
      </p>
      <p className='mb-6'>
        Are you sure you want to delete this voting session?
      </p>
      <div className={styles.votingConfirmActions}>
        <aha-button
          kind='secondary'
          onClick={onCancel}
          class={styles.votingGrowButton}
        >
          Cancel
        </aha-button>
        <aha-button
          kind='danger'
          onClick={onConfirm}
          class={styles.votingGrowButton}
        >
          <aha-icon icon='fa-regular fa-trash' />
          Delete
        </aha-button>
      </div>
    </div>
  );
};

export default ApplicationView(DeleteConfirmation);
